<script lang="ts">
  import { defineComponent } from "vue";
  import FicheRapprochement from '@/generated/fiches/FicheRapprochement.vue';
  export default defineComponent({
    extends: FicheRapprochement,
    components: {}
})
</script>
